var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"hero"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subtitle))])])]),_c('history-cases'),_c('Back')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }